import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const SubHeaderContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
}));

export const BreadCrumbHomeText = styled("span")(() => ({
  color: colors.gray500,

  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "28px",
}));

export const IconImage = styled("img")(() => ({
  height: "20px",
  width: "20px",
}));
